import React from 'react';
import styles from './ActionsInRight.module.scss';
import { IconButton } from 'components';
import { icons } from 'assets';
import { inject } from 'mobx-react';
import { EDITOR_STORE } from 'store';
import { ActionsInRightProps } from './types';

const ActionsInRight = (props: ActionsInRightProps) => {
  const {
    [EDITOR_STORE]: { openShotsWizard, openTimelineTagEditor }
  } = props;

  return (
    <div className={styles.container}>
      <IconButton
        icon={icons.label}
        title='Open Timeline Tag Editor'
        onClick={openTimelineTagEditor}
      />
      <IconButton
        icon={icons.magicStick}
        title='Open Shots Wizard'
        onClick={openShotsWizard}
      />
    </div>
  );
};

export default inject(EDITOR_STORE)(ActionsInRight);
